module.exports = __webpack_public_path__ + "img/oldPeopleResponsive.70f0b8b2.png";